import { useSpring, animated } from "@react-spring/web"
import { useState } from "react";
import CustomInput from "../../components/custom-input"

const Register = ({ onSwitch, fn, error }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [repeatedPassword, setRepeatedPassword] = useState("");
    const [success, setSuccess] = useState(false)

    return (
        <div
            className="space-y-10 p-3 md:p-10 rounded-md text-white max-w-3xl"
        >
            <div
                className=""
            >
                <p
                    className="text-lg font-light"
                >
                    Opret dig på MitVærksted
                </p>
                <p
                    className="text-2xl md:text-3xl font-light mb-3"
                >
                    Udnyt alle fordelene med MitVærksted
                </p>
                <p
                    className="font-extralight text-sm"
                >
                    Med Mit værksted har du et online arkiv over din bils servicehistorik.
                    Samtidig kan du, med få klik, både booke tid og bestille tilbud.
                </p>
            </div>
            <div
                className="max-w-md space-y-4"
            >
                <CustomInput
                    focusColor="white"
                    value={email}
                    onChange={e => {
                        setEmail(e.target.value)
                    }}
                    labelText="Email"
                    placeholder="jensen@mail.dk"
                />
                <CustomInput
                    focusColor="white"
                    type="password"
                    value={password}
                    valid={password.length > 5}
                    errorMessage="Password er for kort"
                    onChange={e => {
                        setPassword(e.target.value)
                    }}
                    labelText="Adgangskode"
                    placeholder="******"
                />
                <CustomInput
                    focusColor="white"
                    type="password"
                    value={repeatedPassword}
                    valid={password === repeatedPassword}
                    errorMessage="Password matcher ikke"
                    onChange={e => {
                        setRepeatedPassword(e.target.value)
                    }}
                    labelText="Gentag adgangskode"
                    placeholder="******"
                />
                <div
                    className="flex space-x-3"
                >
                    <animated.button
                        className="bg-skgBlue p-3 rounded-md text-white flex-1 disabled:opacity-50 transition-all"
                        onClick={() => fn(email, password, repeatedPassword).then(message => {
                            setSuccess(message);
                            setPassword("");
                            setRepeatedPassword("");
                        })}
                        disabled={!password || !repeatedPassword || repeatedPassword !== password || password.length < 6}
                    >
                        Registrer
                    </animated.button>
                    <button
                        className="flex-1"
                        onClick={onSwitch}
                    >
                        Gå til login
                    </button>
                </div>
                {
                    success
                        ? (
                            <div
                                className="text-green-400 text-sm"
                            >
                                {success}
                            </div>
                        )
                        : null
                }
                <div
                    className="text-sm"
                >
                    {error}
                </div>
            </div>
        </div>
    )
}

export default Register;